import Scene = Phaser.Scene;
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {SceneService} from "@/services/scene-service";
import SceneUtils from "@/utils/scene-utils";
import {LoadUtils, LoaderState} from "@/utils/load-utils";
import PlayerStore from "@/store/player";

export default class MusicScene extends Scene {

    @lazyInject(TYPES.SceneService)
    private sceneService!: SceneService;

    private canvas!: HTMLCanvasElement;

    private loaderState!: LoaderState;

    constructor() {
        super({ key: 'MusicScene' });
    }

    public preload(): void {
        this.canvas = this.sys.game.canvas;
    }

    public create(): void {
        this.loaderState = new LoaderState();
        LoadUtils.showSimpleLoadingScreen(this, this.canvas, this.loaderState);
        SceneUtils.setCurrentScene(this);

        let player = PlayerStore.getPlayer();

        LoadUtils.loadMusic(this, player);
        this.load.start();

        this.load.once(Phaser.Loader.Events.COMPLETE, () => {
            this.goToNewSceneAfterLoad();
        });
    }

    update(time: number, delta: number) {
        this.loaderState.update(time, delta);
    }

    private goToNewSceneAfterLoad() {
        LoadUtils.goToNewSceneAfterLoad(this, this.sceneService);
    }
}
